<template>
  <BaseForm
    class="contact-form"
    :class="{ small: small }"
    :action="action"
    :response-to="responseTo"
    gtm-submit-event="form_submit_contact-us"
  >
    <template #fields>
      <NameField />
      <EmailField />
      <TelField />
      <FileField />
      <PolicyPrivacyField />
    </template>

    <template #button>
      <ButtonWidget
        class="text-center text-md-right"
        :width="xsOnly ? '100%' : '275px'"
        type="submit"
      >
        Enviar
      </ButtonWidget>
    </template>
  </BaseForm>
</template>

<script>
import BaseForm from "./BaseForm.vue";
import NameField from "./fields/NameField.vue";
import EmailField from "./fields/EmailField.vue";
import TelField from "./fields/TelField.vue";
import FileField from "./fields/FileField.vue";
import PolicyPrivacyField from "./fields/PolicyPrivacyField.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

export default {
  props: {
    action: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    responseTo: {
      type: String,
      required: true,
    },
  },
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  components: {
    BaseForm,
    NameField,
    EmailField,
    TelField,
    FileField,
    PolicyPrivacyField,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.contact-form::v-deep {
  .base-form-fields {
    display: grid;
    gap: 21px;
    grid-template-columns: 1fr;
  }
}
</style>
